import store from "@/state/store";

export default [

  //   {
  //   path: "/",
  //   name: "Home",
  //   meta: {
  //     // authRequired: true,
  //   },
  //   // component: () => import("../views/pages/account/login"),
  //   // component: () => import('@/views/Home.vue')
  //   component: () => import("@/EstateAgency/components/index.vue"),
  // },

  // ------------------ PUBLIC ROUTES ------------------
  {
    path: "/",
    name: "login",
    component: () => import("../views/pages/account/login.vue"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "home" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/pages/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "home" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot-password",
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "home" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/activate/:token",
    name: "ActivateAccount",
    component: () => import("../components/auth/ActivateAccount.vue"),
    meta: {
      public: true, // optional flag
    },
    beforeEnter: (to, from, next) => {
      // Optional: Redirect if no token query param
      if (!to.params.token) {
        next({ name: "login" });
      } else {
        next();
      }
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        next(authRequiredOnPreviousRoute ? { name: "home" } : { ...routeFrom });
      },
    },
  },

  // ------------------ AUTH-PROTECTED ROUTES ------------------
  {
    path: "/xingzheng/dashboard",
    name: "home",
    meta: { authRequired: true },
    component: () => import("../views/pages/admin/index"),
  },
  {
    path: "/accounting/coa",
    name: "coa",
    meta: { authRequired: true },
    component: () => import("../views/pages/accounting/coa"),
  },
  {
    path: "/accounting/je",
    name: "je",
    meta: { authRequired: true },
    component: () => import("../views/pages/accounting/je"),
  },
  {
    path: "/display",
    name: "display",
    meta: { authRequired: true },
    component: () => import("../views/display/display"),
  },
  {
    path: "/tresentry",
    name: "tresentry",
    meta: { authRequired: true },
    component: () => import("../views/display/tresentry"),
  },
  {
    path: "/ledger-summary/:accountId",
    name: "LedgerSummary",
    meta: { authRequired: true },
    component: () => import("@/views/display/LedgerSummary.vue"),
  },
  {
    path: "/form",
    name: "forms_entry",
    meta: { authRequired: true },
    component: () => import("@/views/forms/create.vue"),
  },
  {
    path: "/loan/approval/:token",
    name: "LoanApproval",
    component: () => import("@/components/forms/LoanForm.vue"),
    meta: { public: true }
  },
  {
    path: "/entry/:formType?/:id?",
    name: "Entry",
    meta: { authRequired: true },
    component: () => import("@/views/forms/create.vue"),
    props: true,
  },
  {
    path: "/admin/menu-roles",
    name: "AdminMenuRoles",
    component: () => import("@/views/AdminMenuRoles.vue"),
  },
];
